export default __webpack_public_path__ + "static/media/servicios_adicionales.fb562021.png";